var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("tracking.tracks_details") } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "secondaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.rfrsh"),
              icon: "fa-light fa-rotate-right",
              variant: "light",
              "aria-label": _vm.$t("common.rfrsh"),
            },
            on: {
              click: function ($event) {
                return _vm.getTrack()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.Tracking
                ? [
                    _c(
                      "div",
                      [
                        _vm.flagTOOLBOX && _vm.Tracking.TestCasename
                          ? _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("tracking.testcases"),
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "6" },
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass: "table",
                                            staticStyle: {
                                              "margin-bottom": "0",
                                            },
                                            attrs: {
                                              "aria-label": _vm.$t(
                                                "tracking.testcase_details_label"
                                              ),
                                            },
                                          },
                                          [
                                            _c("caption", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "tracking.testcase_details_caption"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "thead",
                                              { staticClass: "sr-only" },
                                              [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    { attrs: { scope: "col" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("common.field")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "th",
                                                    { attrs: { scope: "col" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("common.value")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.TrackingTestCaseTableFormattedData,
                                                function (item) {
                                                  return _c(
                                                    "tr",
                                                    { key: item.field },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                          attrs: {
                                                            scope: "row",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getFieldTrad(
                                                                item.field
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                        },
                                                        [
                                                          item.field ===
                                                          "CreationDateRq1"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getDate(
                                                                      item.value
                                                                    )
                                                                  )
                                                                ),
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.value
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.flagTOOLBOX
                                ? _vm.$t("tracking.details_request")
                                : _vm.$t("tracking.details"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.flagTOOLBOX
                              ? _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "6" },
                                      },
                                      [
                                        _c("b-table", {
                                          staticClass: "table",
                                          staticStyle: { "margin-bottom": "0" },
                                          attrs: {
                                            "thead-class": "d-none",
                                            fields: _vm.TOOLBOXTableFields,
                                            items:
                                              _vm.TrackingTableFormattedData,
                                            caption: _vm.$t(
                                              "tracking.tracking_details_caption"
                                            ),
                                            "caption-top": "",
                                            "aria-label": "Détails du suivi",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(field)",
                                                fn: function (data) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getFieldTrad(
                                                            data.value
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(value)",
                                                fn: function (data) {
                                                  return [
                                                    data.item.field ===
                                                    "CreationDateRq1"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getDate(
                                                                data.value
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(data.value)
                                                          ),
                                                        ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            4188465039
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _vm.type === "DDD"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.Provider !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.type === "DDD" &&
                                                        _vm.flagCACP
                                                          ? _vm.$t(
                                                              "tracking.provider_ddd"
                                                            )
                                                          : "Provider",
                                                      inputValue:
                                                        _vm.Tracking.Provider ==
                                                        1
                                                          ? "STET"
                                                          : "EBA",
                                                    },
                                                  }
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.Provider !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.type === "DDD" &&
                                                        _vm.flagCACP
                                                          ? _vm.$t(
                                                              "tracking.provider_ddd"
                                                            )
                                                          : "Provider",
                                                      inputValue:
                                                        _vm.Tracking.Provider ==
                                                        1
                                                          ? "STET"
                                                          : "EBA",
                                                    },
                                                  }
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.Tracking.MsgId !== ""
                                          ? _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.getInputLabel(),
                                                inputValue: _vm.Tracking.MsgId,
                                              },
                                            })
                                          : _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.getInputLabel(),
                                                inputValue: "-",
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.IBAN !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t("tracking.iban"),
                                                      inputValue:
                                                        _vm.Tracking.IBAN,
                                                    },
                                                  }
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.FileSubmissionId !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.file_submission_id"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .FileSubmissionId,
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.file_submission_id"
                                                      ),
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type != "DDD" && _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.BICFrom != ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.type === "DDD" &&
                                                        _vm.flagCACP
                                                          ? _vm.$t(
                                                              "tracking.bic_from_ddd"
                                                            )
                                                          : _vm.$t(
                                                              "tracking.bic_from"
                                                            ),
                                                      inputValue:
                                                        _vm.Tracking.BICFrom,
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.type === "DDD" &&
                                                        _vm.flagCACP
                                                          ? _vm.$t(
                                                              "tracking.bic_from_ddd"
                                                            )
                                                          : _vm.$t(
                                                              "tracking.bic_from"
                                                            ),
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.Tracking.BICBillable !== "" &&
                                        _vm.Tracking.BICFrom !==
                                          _vm.Tracking.BICBillable &&
                                        _vm.Tracking.BICFrom !== ""
                                          ? _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.bic_billable"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.BICBillable,
                                              },
                                            })
                                          : _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.bic_billable"
                                                ),
                                                inputValue: "-",
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.Tracking.BICTo !== ""
                                          ? _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.bic_to_ddd"
                                                      )
                                                    : _vm.$t("tracking.bic_to"),
                                                inputValue: _vm.Tracking.BICTo,
                                              },
                                            })
                                          : _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.bic_to_ddd"
                                                      )
                                                    : _vm.$t("tracking.bic_to"),
                                                inputValue: "-",
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.IBAN !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.flagCACP
                                                        ? _vm.$t(
                                                            "tracking.flagCACP.beneficiary_bank_country"
                                                          )
                                                        : _vm.$t(
                                                            "administration.country"
                                                          ),
                                                      inputValue:
                                                        _vm.getCountryFromIBAN(
                                                          _vm.Tracking.IBAN
                                                        ),
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.flagCACP
                                                        ? _vm.$t(
                                                            "tracking.flagCACP.beneficiary_bank_country"
                                                          )
                                                        : _vm.$t(
                                                            "administration.country"
                                                          ),
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.FullName !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.name"),
                                                inputValue:
                                                  _vm.Tracking.FullName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Siren !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.siren"),
                                                inputValue: _vm.Tracking.Siren,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Siret !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.siret"),
                                                inputValue: _vm.Tracking.Siret,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.TVAIntracomm !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.tva_intracomm"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.TVAIntracomm,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.LEI !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.select.identifiers.LEIC.label"
                                                ),
                                                inputValue: _vm.Tracking.LEI,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.EUID !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.select.identifiers.EUID.label"
                                                ),
                                                inputValue: _vm.Tracking.EUID,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.ICQX !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.icqx"),
                                                inputValue: _vm.Tracking.ICQX,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.Provider !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.type === "DDD" &&
                                                        _vm.flagCACP
                                                          ? _vm.$t(
                                                              "tracking.provider_ddd"
                                                            )
                                                          : "Provider",
                                                      inputValue:
                                                        _vm.Tracking.Provider ==
                                                        1
                                                          ? "STET"
                                                          : "EBA",
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.type === "DDD" &&
                                                        _vm.flagCACP
                                                          ? _vm.$t(
                                                              "tracking.provider_ddd"
                                                            )
                                                          : "Provider",
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.Reference !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.flagCACP
                                                        ? _vm.$t(
                                                            "tracking.flagCACP.msg_id_request_provider"
                                                          )
                                                        : _vm.$t(
                                                            "tracking.reference"
                                                          ),
                                                      inputValue:
                                                        _vm.Tracking.Reference,
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.flagCACP
                                                        ? _vm.$t(
                                                            "tracking.flagCACP.msg_id_request_provider"
                                                          )
                                                        : _vm.$t(
                                                            "tracking.reference"
                                                          ),
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.AdditionalInformation !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.additional_information"
                                                ),
                                                inputValue:
                                                  _vm.Tracking
                                                    .AdditionalInformation,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.CreationDateRq1 !== ""
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.creation_date_request_1_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.creation_date_request_1"
                                                      ),
                                                inputValue: _vm.getDate(
                                                  _vm.Tracking.CreationDateRq1
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Request2CreationDate !== "" &&
                                    _vm.type != "DDD" &&
                                    _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.creation_date_request_2_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.creation_date_request_2"
                                                      ),
                                                inputValue: _vm.getDate(
                                                  _vm.Tracking
                                                    .Request2CreationDate
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.CreationDateRq1 !== "" &&
                                    _vm.Tracking.CreationDateRp2 !== "" &&
                                    _vm.type === "DDD" &&
                                    _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.response_time_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "common.response_time"
                                                      ),
                                                inputValue: _vm.getDuration(
                                                  _vm.Tracking
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Tracking !== "" &&
                                    _vm.type === "DDD" &&
                                    _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.technical_code_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.technical_code"
                                                      ),
                                                inputValue:
                                                  _vm.Tracking
                                                    .TechStatusCode !== ""
                                                    ? _vm.translateTechStatusCode(
                                                        _vm.Tracking
                                                          .TechStatusCode
                                                      )
                                                    : _vm.$t(
                                                        "common.monitoring.success"
                                                      ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDD" && _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.result_ddd"
                                                ),
                                                inputValue: _vm.getResultDDD(
                                                  _vm.Tracking
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hr", { staticClass: "mx-auto" }),
                        _vm._v(" "),
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("tracking.response"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.flagTOOLBOX
                              ? _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "6" },
                                      },
                                      [
                                        _c("b-table", {
                                          staticClass: "table",
                                          staticStyle: { "margin-bottom": "0" },
                                          attrs: {
                                            "thead-class": "d-none",
                                            fields: _vm.TOOLBOXTableFields,
                                            items:
                                              _vm.TrackingTableRespFormattedData,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(field)",
                                                fn: function (data) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getFieldTrad(
                                                            data.value
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(value)",
                                                fn: function (data) {
                                                  return [
                                                    data.item.field ===
                                                    "NameScore"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getResultText(
                                                                data.value
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : data.item.field ===
                                                        "CreationDateRp2"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getDate(
                                                                data.value
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(data.value)
                                                          ),
                                                        ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2358928436
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _vm.Tracking.CreationDateRp2 !== "" &&
                                    _vm.type != "DDD" &&
                                    _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.creation_date_response_2_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.creation_date_response_2"
                                                      ),
                                                inputValue: _vm.getDate(
                                                  _vm.Tracking.CreationDateRp2
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Response2CreationDate !== ""
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.creation_date_response_1_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.creation_date_response_1"
                                                      ),
                                                inputValue: _vm.getDate(
                                                  _vm.Tracking
                                                    .Response2CreationDate
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.flagCACP && _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.flagCACP.demande_status"
                                                ),
                                                inputValue:
                                                  _vm.Tracking
                                                    .TechStatusCode !== ""
                                                    ? _vm.translateTechStatusCode(
                                                        _vm.Tracking
                                                          .TechStatusCode
                                                      )
                                                    : _vm.$t(
                                                        "common.monitoring.success"
                                                      ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.IdScore !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.id_score"),
                                                inputValue: _vm.getResultText(
                                                  _vm.Tracking.IdScore
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.NameScore !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.name_score"
                                                ),
                                                inputValue: _vm.getResultText(
                                                  _vm.Tracking.NameScore
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.IdScore !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.check_result"
                                                      ),
                                                      inputValue:
                                                        _vm.getResultText(
                                                          _vm.Tracking.IdScore
                                                        ),
                                                    },
                                                  }
                                                )
                                              : _vm.Tracking.NameScore !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.check_result"
                                                      ),
                                                      inputValue:
                                                        _vm.getResultText(
                                                          _vm.Tracking.NameScore
                                                        ),
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.check_result"
                                                      ),
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.ReasonCode !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.reason_code_optional"
                                                      ),
                                                      inputValue: _vm.$t(
                                                        "tracking.flagCACP.reason_code_optional_list." +
                                                          _vm.Tracking
                                                            .ReasonCode
                                                      ),
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.reason_code_optional"
                                                      ),
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.IdScore2 !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.check_result_entity"
                                                      ),
                                                      inputValue:
                                                        _vm.getResultText(
                                                          _vm.Tracking.IdScore2
                                                        ),
                                                    },
                                                  }
                                                )
                                              : _vm.Tracking.NameScore2 !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.check_result_entity"
                                                      ),
                                                      inputValue:
                                                        _vm.getResultText(
                                                          _vm.Tracking
                                                            .NameScore2
                                                        ),
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.check_result_entity"
                                                      ),
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.ReasonCodeEntity !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.reason_code_optional_entity"
                                                      ),
                                                      inputValue: _vm.$t(
                                                        "tracking.flagCACP.reason_code_optional_entity_list." +
                                                          _vm.Tracking
                                                            .ReasonCodeEntity
                                                      ),
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.flagCACP.reason_code_optional_entity"
                                                      ),
                                                      inputValue: "-",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "common.response_time"
                                                ),
                                                inputValue: _vm.Tracking
                                                  ? _vm.getDuration(
                                                      _vm.Tracking
                                                    )
                                                  : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.RealName !== "" &&
                                    _vm.type === "DDV" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.real_name"),
                                                inputValue:
                                                  _vm.Tracking.RealName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV" && _vm.flagCACP
                                      ? _c("b-col", {
                                          staticClass: "mb-5",
                                          attrs: { sm: "4" },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _vm.type == "DDD" &&
                            (_vm.Tracking.LastName !== "" ||
                              _vm.Tracking.BirthName !== "" ||
                              _vm.Tracking.FirstName !== "" ||
                              _vm.Tracking.MarriedName !== "")
                              ? _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _vm.Tracking.FirstName !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.first_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.FirstName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.LastName !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.last_name"),
                                                inputValue:
                                                  _vm.Tracking.LastName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.BirthName !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.birth_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.BirthName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.MarriedName !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.married_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.MarriedName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.FirstName2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.first_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.FirstName2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.LastName2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.last_name"),
                                                inputValue:
                                                  _vm.Tracking.LastName2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.BirthName2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.birth_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.BirthName2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.MarriedName2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.married_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.MarriedName2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.type === "DDD" &&
                            (_vm.Tracking.CompanyName !== "" ||
                              _vm.Tracking.Siren !== "" ||
                              _vm.Tracking.Siret !== "" ||
                              _vm.Tracking.TVAIntracomm !== "")
                              ? _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _vm.Tracking.CompanyName !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.company_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.CompanyName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.TradingName !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "annuaire.trading_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.TradingName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Siren !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.siren"),
                                                inputValue: _vm.Tracking.Siren,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Siret !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.siret"),
                                                inputValue: _vm.Tracking.Siret,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.TVAIntracomm !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.tva_intracomm"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.TVAIntracomm,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.LEI !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.select.identifiers.LEIC.label"
                                                ),
                                                inputValue: _vm.Tracking.LEI,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.EUID !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.select.identifiers.EUID.label"
                                                ),
                                                inputValue: _vm.Tracking.EUID,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.CompanyName2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.company_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.CompanyName2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.TradingName2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "annuaire.trading_name"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.TradingName2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Siren2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.siren"),
                                                inputValue: _vm.Tracking.Siren2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Siret2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.siret"),
                                                inputValue: _vm.Tracking.Siret2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.TVAIntracomm2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.tva_intracomm"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.TVAIntracomm2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.LEI2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.select.identifiers.LEIC.label"
                                                ),
                                                inputValue: _vm.Tracking.LEI2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.EUID2 !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.select.identifiers.EUID.label"
                                                ),
                                                inputValue: _vm.Tracking.EUID2,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.type === "DDD" &&
                            _vm.Tracking.Status === "0" &&
                            (_vm.Tracking.ReasonCode !== "" ||
                              _vm.Tracking.ReasonDescription !== "")
                              ? _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _vm.Tracking.ReasonCode !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.reason_code"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.ReasonCode,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.ReasonDescription !== "" &&
                                    _vm.type === "DDD" &&
                                    !_vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.reason_description"
                                                ),
                                                inputValue:
                                                  _vm.Tracking
                                                    .ReasonDescription,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr", { staticClass: "mx-auto" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("tracking.history"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.Tracking.History && _vm.Tracking.History.length
                              ? _c(
                                  "table",
                                  {
                                    staticClass: "table table-striped",
                                    attrs: {
                                      "aria-label": _vm.$t(
                                        "tracking.history_table"
                                      ),
                                    },
                                  },
                                  [
                                    _c("caption", { staticClass: "sr-only" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("tracking.history_caption")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("thead", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-center w-25",
                                            attrs: { scope: "col" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("tracking.status")
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-center w-25",
                                            attrs: { scope: "col" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("tracking.status_code")
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-center w-25",
                                            attrs: { scope: "col" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "tracking.processing_date"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-center w-25",
                                            attrs: { scope: "col" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("common.actions")
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.Tracking.History,
                                        function (history) {
                                          return _c("tr", { key: history.id }, [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "text-center w-25",
                                              },
                                              [
                                                history.Status !== ""
                                                  ? _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "tracking.status-" +
                                                              history.Status
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "text-center w-25",
                                              },
                                              [
                                                history.StatusCode !== ""
                                                  ? _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.translateTechStatusCode(
                                                            history.StatusCode
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "text-center w-25",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getDate(
                                                        history.DateTime
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-center align-middle w-25",
                                              },
                                              [
                                                history.Status === "1" ||
                                                history.Status === "10" ||
                                                history.Status === "30" ||
                                                history.Status === "45" ||
                                                history.Status === "50" ||
                                                history.Status === "100" ||
                                                history.Status === "110" ||
                                                history.Status === "125" ||
                                                history.Status === "160"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex justify-content-center align-item-center",
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-link p-0 mr-2",
                                                            attrs: {
                                                              type: "button",
                                                              "aria-label":
                                                                _vm.$t(
                                                                  "common.view_details"
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.seeJson(
                                                                  history.IdMsg,
                                                                  "historyTracking",
                                                                  "see"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-eye color-var-actionButtonColorBlue",
                                                              attrs: {
                                                                "aria-hidden":
                                                                  "true",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-link p-0",
                                                            attrs: {
                                                              type: "button",
                                                              "aria-label":
                                                                _vm.$t(
                                                                  "common.download"
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.seeJson(
                                                                  history.IdMsg,
                                                                  "historyTracking",
                                                                  "download"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-download color-var-actionButtonColorBlue",
                                                              attrs: {
                                                                "aria-hidden":
                                                                  "true",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }